<div class="track-page">
  <div class="columns">
    <div class="filters">
      <twc-tab-menu [menuItems]="trackFilters()"></twc-tab-menu>
    </div>
    <div class="column-main">
      @if (!busy()) {
        @for (
          shipment of filteredShipments();
          track shipment.pro_number;
          let first = $first
        ) {
          <twc-expandable-panel
            defaultIconName="lt:ic-shipment"
            defaultIconColorClass="twc-icon-stroke-secondary-typeface"
            activeIconColorClass="twc-icon-stroke-white"
            defaultIconWrapperBgClass="twc-bg-color-fields-background"
            activeIconWrapperBgClass="twc-bg-color-link"
            [titleTemplate]="titleTemplate"
            [metaTextTemplate]="metaTextTemplate"
            [expanded]="first"
          >
            <lt-shipment-info [shipment]="shipment"></lt-shipment-info>
          </twc-expandable-panel>

          <ng-template #titleTemplate>
            <div class="display-flex flex-direction-column gap-1">
              <div
                class="twc-typography-body-1-semi-bold twc-color-main-typeface"
              >
                #{{
                  shipment.pro_number || shipment.reference_numbers?.[0]?.value
                }}
              </div>
              <div class="twc-typography-body-1-medium twc-color-main-typeface">
                {{ shipment.displayStatus }}
              </div>
            </div>
          </ng-template>

          <ng-template #metaTextTemplate>
            <div class="twc-typography-body-1 twc-color-secondary-typeface">
              Updated: {{ shipment.last_update_at | lastUpdatedText }}
            </div>
          </ng-template>
        }
        @if (!filteredShipments().length) {
          <div
            class="no-results twc-typography-body-2 twc-color-secondary-typeface text-align-center"
          >
            No matching shipments found.
          </div>
        }
      } @else {
        <div class="loading-container">
          <mat-progress-spinner
            color="primary"
            mode="indeterminate"
            strokeWidth="4"
            diameter="64"
          ></mat-progress-spinner>
        </div>
      }
    </div>
    <div class="column-side">
      <lt-tracker
        [(trackingNumbers)]="trackingNumbers"
        [(customerReference)]="customerReference"
      ></lt-tracker>
    </div>
  </div>
</div>
